import FormInputRadioButton from './component.jsx'
export default FormInputRadioButton
